import React from "react";
import { TemplateWrapped } from "../../Layout";
import { Button } from "../../ui/button";
import { ChevronDown, FileText, Upload } from "lucide-react";
import { ConversionTypePopover } from "./components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useFileConverterDiva } from "./hooks/useFileConverterDiva";

const FileConverterDiva = () => {
  const {
    anchorEl,
    handleClose,
    handleClick,
    conversionType,
    handleConversionTypeSelect,
    handleDragLeave,
    handleDragOver,
    handleDrop,
    handleFileSelect,
    isProcessingFile,
    selectedFile,
    open,
    id,
    isDragOver,
    processHandler,
  } = useFileConverterDiva();
  return (
    <TemplateWrapped
      title="Insurance Verification | All Transactions"
      headerButtons={<></>}
      showTitle={false}
    >
      <div
        className="panel"
        style={{ backgroundColor: "transparent", boxShadow: "none" }}
      >
        <div className="panel-body justify-center">
          <main className="flex-1 overflow-auto pt-6 pb-8">
            {/* Page Header */}
            <div className="mb-8">
              <h1 className="text-2xl font-bold text-gray-900 mb-2">Tools</h1>
              <p className="text-gray-500">
                Use utilities features to support daily operations
              </p>
            </div>

            <div className="max-w-screen-sm mx-auto">
              <div className="bg-white rounded-xl border border-gray-200 p-6 mb-6 max-w-screen-sm">
                <h4 className="tracking-tight text-xl font-medium">
                  File Converter
                </h4>
                <p className="text-gray-500 tools-description">
                  Convert documents between formats like .docx and .pdf. Max
                  file size: 20MB.
                </p>

                <div className="flex">
                  <Button
                    aria-describedby={id}
                    size="sm"
                    variant="outline"
                    className="!rounded-[0.75rem] !px-5 !py-5 !flex items-center !justify-between !gap-[2rem] !text-gray-600 !hover:bg-accent !hover:text-accent-foreground !w-full"
                    onClick={(ev) => {
                      ev.stopPropagation();
                      handleClick(ev);
                    }}
                  >
                    {conversionType
                      ? conversionType.label
                      : "Select conversion type"}{" "}
                    <ChevronDown className="w-4 h-4" />
                  </Button>
                </div>

                <div className="space-y-2">
                  <label className="text-md font-normal text-gray-700 mt-3">
                    Select File
                  </label>
                  <div
                    className={`border-2 border-dashed rounded-lg p-8 text-center transition-colors ${
                      isDragOver
                        ? "border-blue-400 bg-blue-50"
                        : "border-gray-300 hover:border-gray-400"
                    }`}
                    onDragOver={handleDragOver}
                    onDragLeave={handleDragLeave}
                    onDrop={handleDrop}
                  >
                    <div className="flex flex-col items-center space-y-4">
                      <Upload className="w-8 h-8 text-gray-400" />
                      <div className="space-y-2">
                        <p className="text-gray-600">
                          {selectedFile
                            ? selectedFile.name
                            : "Drop your file here or click to browse"}
                        </p>
                        <input
                          type="file"
                          id="file-upload"
                          className="hidden"
                          onChange={handleFileSelect}
                          accept={conversionType?.accept || ""}
                          disabled={!conversionType}
                        />
                        <Button
                          variant="outline"
                          onClick={() =>
                            document.getElementById("file-upload")?.click()
                          }
                          className="flex items-center gap-2"
                          disabled={!conversionType}
                        >
                          <FileText className="w-4 h-4" />
                          Browse Files
                        </Button>
                      </div>
                    </div>
                  </div>
                  <p className="text-xs text-gray-500">
                    Supported formats: PDF, DOCX, Image files. Max 20MB.
                  </p>
                </div>

                {/* Process Button */}
                <div className="flex justify-end mt-4">
                  <Button
                    className={`!bg-teal-600 hover:bg-teal-800 text-white !rounded-xl !h-9 !mt-3z`}
                    disabled={
                      !selectedFile || !conversionType || isProcessingFile
                    }
                    type="button"
                    onClick={processHandler}
                  >
                    {isProcessingFile ? (
                      <div>
                        <FontAwesomeIcon spin icon="spinner" /> Processing
                        file...
                      </div>
                    ) : (
                      "Process File"
                    )}
                  </Button>
                </div>
              </div>
            </div>
          </main>
        </div>
      </div>

      <ConversionTypePopover
        anchorEl={anchorEl}
        handleClose={handleClose}
        id={id}
        conversionType={conversionType}
        open={open}
        handleConversionTypeSelect={handleConversionTypeSelect}
      />
    </TemplateWrapped>
  );
};

export default FileConverterDiva;
